export const storeDepositLink = (link) => {
  return {
    type: "storeDepositLink",
    payload: link,
  };
};
